var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "950",
                  "custom-sim-query-placeholder":
                    _vm.$t("advanceSearchForm.quickSearch") +
                    ":" +
                    _vm.$t("SeaExport.MasterBillNo"),
                  "sim-query-filter-function": _vm.simQueryFilterFunction
                },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "1" },
                        on: { click: _vm.registrationHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Register")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "2" },
                        on: { click: _vm.invalidClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Void")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_mawb_detch"],
                            expression: "['button_mawb_detch']"
                          }
                        ],
                        attrs: { type: "primary", no: "3" },
                        on: { click: _vm.detchHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Unbind")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "4" },
                        on: { click: _vm.assignmentHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Assignment")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_SetMarginReminder_remindMargin"],
                            expression:
                              "['button_SetMarginReminder_remindMargin']"
                          }
                        ],
                        attrs: { type: "primary", no: "setMargin" },
                        on: { click: _vm.setMarginReminder }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SetMarginReminder"))
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "5" },
                        on: { click: _vm.statisticsHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Statistics")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "check-main-record": false,
                    "deselect-main-record": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    total: _vm.total,
                    page: _vm.pageNum,
                    limit: _vm.pageSize,
                    no: "5"
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:limit": function($event) {
                      _vm.pageSize = $event
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("registration-dialog", {
        attrs: { visible: _vm.registrationDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.registrationDialog, "visible", $event)
          }
        }
      }),
      _c("assignment-dialog", {
        attrs: { visible: _vm.assignmentDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.assignmentDialog, "visible", $event)
          },
          returnCallBack: function($event) {
            return _vm.assignment($event)
          }
        }
      }),
      _c("margin-reminder-dialog", {
        attrs: {
          visible: _vm.marginReminderDialog.visible,
          "office-id": _vm.marginReminderDialog.officeId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.marginReminderDialog, "visible", $event)
          }
        }
      }),
      _c("statistics-dialog", {
        attrs: { visible: _vm.selectStatisticsDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectStatisticsDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }